module.exports = __webpack_public_path__ + "assets/img/WAREHOUSE.cea0ab79.svg";